import { Navigate, useLocation } from "react-router-dom";
import { useAdminAuth } from "../../context/AdminAuthContext";
import { ADMIN_LOGIN_PATH } from "../../lib/adminPaths";

/**
 * @param {{ children: import("react").ReactNode }} props
 */
export default function AdminRequireAuth({ children }) {
  const { user, loading } = useAdminAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="admin-page admin-page--centered">
        <p className="admin-muted">Checking session…</p>
      </div>
    );
  }

  if (!user) {
    return <Navigate to={ADMIN_LOGIN_PATH} replace state={{ from: location.pathname }} />;
  }

  return children;
}
